export default "__VITE_ASSET__y0RhHy8V__"